import { MessageCircle, Camera } from "lucide-react";
import { COMPANY } from "@/lib/company";
import { trackEstimate, trackWhatsApp } from "@/lib/track";

export default function StickyMobileBar() {
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 bg-white border-t border-neutral-200 shadow-[0_-6px_20px_rgba(0,0,0,0.08)]"
    >
      <a
        href="#lead-form"
        data-testid="sticky-estimate"
        onClick={() => trackEstimate("sticky_bar")}
        className="flex items-center justify-center gap-2 py-4 bg-[#C5A059] text-white active:bg-[#A88746]"
      >
        <Camera className="w-5 h-5" />
        <span className="text-[12px] font-semibold tracking-wide">GET ESTIMATE</span>
      </a>
      <a
        href={COMPANY.estimateLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp"
        onClick={() => trackWhatsApp("sticky_bar")}
        className="flex items-center justify-center gap-2 py-4 bg-[#25D366] text-white active:bg-[#1ebd5a]"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="text-[12px] font-semibold tracking-wide">WHATSAPP</span>
      </a>
    </div>
  );
}
